var _path, _path2, _path3, _path4, _path5, _path6;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRequest(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.2852 11.7266L18.6548 15.3438H21.321C21.4554 15.3385 21.5882 15.3749 21.7012 15.4479C21.8142 15.521 21.9019 15.6271 21.9523 15.7519C22.0027 15.8767 22.0133 16.014 21.9827 16.145C21.9521 16.2761 21.8818 16.3944 21.7813 16.484L19.4706 18.0971L20.7522 21.0423C20.8081 21.1772 20.8205 21.3262 20.7874 21.4684C20.7543 21.6106 20.6775 21.7389 20.5678 21.8352C20.458 21.9315 20.3209 21.991 20.1756 22.0053C20.0303 22.0196 19.8841 21.9881 19.7577 21.9151L16.6569 20.1723L13.5579 21.9151C13.4314 21.9881 13.2853 22.0196 13.14 22.0053C12.9947 21.991 12.8575 21.9315 12.7478 21.8352C12.638 21.7389 12.5612 21.6106 12.5281 21.4684C12.4951 21.3262 12.5074 21.1772 12.5634 21.0423L13.8458 18.0971L11.5351 16.484C11.4343 16.3948 11.3637 16.2767 11.3327 16.1457C11.3017 16.0148 11.312 15.8775 11.3621 15.7526C11.4123 15.6277 11.4998 15.5214 11.6127 15.4482C11.7256 15.375 11.8583 15.3385 11.9928 15.3438H14.659L16.0312 11.7266C16.0919 11.6131 16.1823 11.5181 16.2927 11.452C16.4031 11.3858 16.5295 11.3508 16.6582 11.3508C16.7869 11.3508 16.9133 11.3858 17.0237 11.452C17.1341 11.5181 17.2245 11.6131 17.2852 11.7266Z",
    stroke: "#2B2B2B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.00098 10.6779H11.9999",
    stroke: "#2B2B2B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.00098 14.0107H8.00063",
    stroke: "#2B2B2B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.00098 17.3434H8.00063",
    stroke: "#2B2B2B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.33378 22.0093H3.33481C2.98125 22.0093 2.64217 21.8688 2.39217 21.6188C2.14216 21.3688 2.00171 21.0297 2.00171 20.6762V6.67856C2.00171 6.325 2.14216 5.98592 2.39217 5.73591C2.64217 5.48591 2.98125 5.34546 3.33481 5.34546H6.66758C6.66758 4.46155 7.0187 3.61385 7.64372 2.98884C8.26873 2.36382 9.11643 2.0127 10.0003 2.0127C10.8842 2.0127 11.7319 2.36382 12.357 2.98884C12.982 3.61385 13.3331 4.46155 13.3331 5.34546H16.6659C17.0194 5.34546 17.3585 5.48591 17.6085 5.73591C17.8585 5.98592 17.999 6.325 17.999 6.67856V8.67822",
    stroke: "#2B2B2B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0003 4.67889C10.0662 4.67889 10.1306 4.69844 10.1854 4.73506C10.2402 4.77168 10.283 4.82373 10.3082 4.88463C10.3334 4.94553 10.34 5.01254 10.3271 5.07719C10.3143 5.14184 10.2825 5.20122 10.2359 5.24783C10.1893 5.29444 10.1299 5.32618 10.0653 5.33904C10.0006 5.3519 9.93363 5.3453 9.87273 5.32008C9.81183 5.29485 9.75978 5.25214 9.72316 5.19733C9.68654 5.14252 9.66699 5.07809 9.66699 5.01217C9.66699 4.92378 9.7021 4.83901 9.76461 4.77651C9.82711 4.71401 9.91188 4.67889 10.0003 4.67889",
    stroke: "#2B2B2B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRequest);
export default __webpack_public_path__ + "static/media/request.0f4ea224.svg";
export { ForwardRef as ReactComponent };